import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';

export const PaywallBanner = () => {
  const navigate = useNavigate();
  const { billing, isSuperAdmin } = useAuth();
  if (isSuperAdmin) return null;
  if (!billing) return null;
  if (!billing.is_trial && billing.subscription_status === 'active') return null;

  if (billing.blocked) {
    return (
      <div
        className="bg-rose-600 text-white px-4 py-2.5 text-sm flex items-center justify-between gap-3 flex-wrap"
        data-testid="paywall-blocked-banner"
      >
        <div className="flex items-center gap-2 min-w-0">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span className="truncate">
            <strong>Trial expirado.</strong> Sua conta está em <strong>modo somente leitura</strong>. Assine para continuar editando.
          </span>
        </div>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => navigate('/billing')}
          className="bg-white text-rose-700 hover:bg-rose-50"
          data-testid="paywall-blocked-cta"
        >
          <Sparkles className="h-4 w-4 mr-1.5" />
          Assinar agora
        </Button>
      </div>
    );
  }

  if (billing.is_trial && typeof billing.days_left === 'number') {
    const urgent = billing.days_left <= 2;
    return (
      <div
        className={`px-4 py-2.5 text-sm flex items-center justify-between gap-3 flex-wrap ${
          urgent ? 'bg-amber-500 text-white' : 'bg-amber-50 text-amber-900 border-b border-amber-200'
        }`}
        data-testid="paywall-trial-banner"
      >
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles className="h-4 w-4 shrink-0" />
          <span className="truncate">
            {billing.days_left > 0
              ? <>Você tem <strong>{billing.days_left}</strong> {billing.days_left === 1 ? 'dia' : 'dias'} restantes do seu período de teste.</>
              : <>Seu trial termina hoje. Garanta o acesso contínuo.</>}
          </span>
        </div>
        <Button
          size="sm"
          variant={urgent ? 'secondary' : 'default'}
          onClick={() => navigate('/billing')}
          className={urgent ? 'bg-white text-amber-700 hover:bg-amber-50' : 'bg-amber-600 hover:bg-amber-700 text-white'}
          data-testid="paywall-trial-cta"
        >
          Ver planos
        </Button>
      </div>
    );
  }

  return null;
};

export default PaywallBanner;
